<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
              <h1>Instructivos de embarque</h1>
              <v-server-table
                :url="url"
                :columns="columns"
                :options="options"
                :theme="theme"
                ref="table"
                id="dataTable"
              >
                <div slot="beforeLimit">
                  <download-excel
                    class="btn"
                    :fetch="fetchData"
                    :fields="json_fields2"
                    worksheet="Embarques"
                    :name="name"
                    :before-generate="startDownload"
                    :before-finish="finishDownload"
                  >
                    <b-link>Descargar</b-link>
                  </download-excel>
                </div>

                <template slot="afterFilter">
                  <tr v-if="loading" class="VueTables__no-results">
                    <b-spinner
                      v-if="loading"
                      variant="primary"
                      class="ml-2 mt-1"
                      small
                      label="Small Spinner"
                    ></b-spinner>
                  </tr>
                </template>

                <template slot="shipment_status" slot-scope="props">
                  <div style="text-align: center">
                    <b-badge pill :variant="getBadge(props.row.shipment_status)"
                      >{{ status(props.row.shipment_status) }}
                    </b-badge>
                  </div>
                </template>

                <template slot="shipment_date" slot-scope="props">
                  {{ props.row.shipment_date | fecha }}
                </template>

                <div class="text-right" slot="actions" slot-scope="props">
                  <a
                    target="_blank"
                    href="#"
                    @click.prevent="
                      downloadWithAxios(props.row.id, props.row.boarding_number)
                    "
                    class="fa fa-lg fa fa-list text-black-50"
                    title="Packing List"
                  ></a
                  >&nbsp;
                  <a
                    target="_blank"
                    href="#"
                    @click.prevent="showBoardinInstructiveModal(props.row.id)"
                    class="fa fa-lg fa fa-plane text-black-50"
                    title="Instructivo Embarque"
                  ></a
                  >&nbsp;
                  <!-- <a target="_blank" href="#" @click.prevent="showExportInvoiceModal(props.row.id)"
                     class="fa fa-lg fa fa-usd text-black-50" title="Factura de Exportación"></a>&nbsp; -->
                  <a
                    target="_blank"
                    href="#"
                    @click.prevent="editShipment(props.row)"
                    class="fa fa-lg fa-edit text-black-50"
                  ></a
                  >&nbsp;
                  <!--  <a target="_blank" @click.prevent="deleteWaybill(props.row.id)" href="#" class="fa fa-lg fa-trash text-danger"></a> -->
                </div>
              </v-server-table>

              <b-modal
                v-model="modalShownBordingInstructive"
                centered
                size="lg"
                title="Instructivos de embarque"
                hide-footer
              >
                <component
                  :is="componenteActual"
                  :idBording="idBording"
                  :shipment="shipment"
                  :ref="report"
                ></component>
              </b-modal>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import ReportInstructivoEmbarqueMaritimo from "./ReportInstructivoEmbarqueMaritimo.vue";
import ReportInstructivoEmbarqueAereo from "./ReportInstructivoEmbarqueAereo.vue";
import ReportFacturaExportacion from "./ReportFacturaExportacion.vue";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

window.axios = require("axios");

Vue.component("downloadExcel", JsonExcel);

Vue.use(ServerTable);

export default {
  name: "ListInstruccionEmbarque",
  components: {
    ServerTable,
    ReportInstructivoEmbarqueMaritimo,
    ReportInstructivoEmbarqueAereo,
    ReportFacturaExportacion
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
  },
  props: ["BoardingID"],
  data() {
    return {
      loading: false,
      modalShownBordingInstructive: false,
      idBording: 0,
      shipment: "",
      componenteActual: "",
      report: "",
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      columns: [
        // 'id',
        "boarding_number",
        "shipment_date",
        "products",
        "shipment_type.name",
        "exporter_name",
        "consignee_name",
        "country.name",
        "box_containers",
        "total_pallets",
        "total_boxes",
        "shipment_status",
        "actions"
      ],
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        debounce: 700,
        // columnsDropdown: true,
        filterByColumn: false,
        headings: {
          boarding_number: "Embarque",
          products: "Producto",
          "shipment_type.name": "Tipo",
          exporter_name: "Exportadora",
          consignee_name: "Consignatario",
          "country.name": "Pais",
          box_containers: "Formato",
          total_pallets: "Pallets",
          shipment_date: "Fecha Embarque",
          total_boxes: "Cajas",
          shipment_status: "Estatus",
          actions: "Acciones"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      json_fields2: {
        Embarque: "boarding_number",
        Producto: "products",
        Tipo: "shipment_type.name",
        Consignatario: "consignee_company.name",
        Pais: "country.name",
        Mercado: "country.market",
        Formato: "box_containers",
        Pallets: "total_pallets",
        Cajas: "total_boxes",
        Estatus: "shipment_status"
      }
    };
  },
  filters: {
    fecha(value) {
      return moment(value).format("DD-MM-YYYY");
    }
  },
  computed: {
    url() {
      return "/api/comex/shipment/detailed/";
    },
    name() {
      return (
        "ListInstruccionEmbarque " +
        moment(Date.now()).format("YYYYMMDD h:mm") +
        ".xls"
      );
    }
  },
  methods: {
    async fetchData() {
      const response = await this.$axios.get("/api/comex/shipment/detailed/");

      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },
    status(shipment_status) {
      return shipment_status === 2 ? "DESPACHADO" : "ABIERTO";
    },
    getBadge(shipment_status) {
      return shipment_status === 2 ? "dark" : "light";
    },

    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Packing List - Embarque #" + a + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: "/api/comex/shipment/" + a + "/packing_list/",
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
          miniToastr.success(
            "Packing list generado con éxito.",
            "Packing List:"
          );
        })
        .catch((error) => {
          miniToastr.error("Problemas al generar packing list", "Error:");
          console.log(error);
        });
    },

    showBoardinInstructiveModal(a) {
      this.$axios({
        method: "get",
        url: "/api/comex/shipment/" + a + "/detailed_shipment/"
      })
        .then((response) => {
          a = response.data;
          //es maritimo
          if (a.shipment_type.id == 1) {
            this.modalShownBordingInstructive = true;
            this.idBording = a.id;
            this.shipment = a;
            this.componenteActual = "ReportInstructivoEmbarqueMaritimo";

            this.report = "report";
            this.$nextTick(function () {
              this.$refs.report.calcular();
            });
          }

          //es aereo
          if (a.shipment_type.id == 2) {
            this.modalShownBordingInstructive = true;
            this.idBording = a.id;
            this.shipment = a;
            this.componenteActual = "ReportInstructivoEmbarqueAereo";

            this.report = "report";
            this.$nextTick(function () {
              this.$refs.report.calcular();
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showExportInvoiceModal(a) {
      this.$axios({
        method: "get",
        url: "/api/comex/shipment/" + a + "/detailed_shipment/"
      })
        .then((response) => {
          a = response.data;
          this.modalShownBordingInstructive = true;
          this.idBording = a.id;
          this.shipment = a;
          this.componenteActual = "ReportFacturaExportacion";

          this.report = "report";
          this.$nextTick(function () {
            this.$refs.report.calcular();
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editShipment(a) {
      //console.log(a.id);
      this.$router.push("/exportacion/editar/" + a.id);
    },
    onComplete() {}
  },
  beforeMount() {}
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
